// extracted by mini-css-extract-plugin
export default {"page":"root_page__ZRfdF"};